import { Grid } from "@mui/material";
import { apiClient } from "api/apiClient";
import { useEffect, useState } from "react";
import Box from "ReusableComponents/Box";
import H2 from "ReusableComponents/Text/H2";
import { SIZES } from "theme";
import Carousel from "./components/Carousel";

const CustomerSection = ({ small }) => {
  const [customerData, setCustomerData] = useState(null);

  useEffect(() => {
    if (!customerData) { // Only make the API call if customerData is empty
      apiClient.getCustomerData().then((res) => {
        setCustomerData(res?.data);
      });
    }
  }, [customerData]); // Dependency array is empty

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "auto",
        padding: small ? "0px" : "24px",
      }}
    >
      <Grid item xs={12}>
        <Box
          margin={small ? "10px" : "24px 0"}
          textAlign="center"
          display="flex"
          flexDirection="column"
        >
          <H2
            textColor="black"
            fontWeight="bold"
            fontSize={small ? SIZES.twenty : "40px"}
            margin="16px 0"
          >
            We let our customers speak for us
          </H2>
        </Box>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          alignContent: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Carousel small={small} customerData={customerData} />
      </Grid>
    </Grid>
  );
};

export default CustomerSection;
